import { render, staticRenderFns } from "./WorksEdit.vue?vue&type=template&id=60b6a9b2&scoped=true&"
import script from "./WorksEdit.vue?vue&type=script&lang=js&"
export * from "./WorksEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorksEdit.vue?vue&type=style&index=0&id=60b6a9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6a9b2",
  null
  
)

export default component.exports